"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeType = exports.ThemeSpacingMap = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var b2c_theme_1 = require("../Theme/b2c-theme");
var Divider_1 = __importDefault(require("../Divider/Divider"));
var Typography_1 = __importStar(require("../Typography/Typography"));
var ThemeSpacingMap;
(function (ThemeSpacingMap) {
    ThemeSpacingMap[ThemeSpacingMap["default"] = 1] = "default";
    ThemeSpacingMap[ThemeSpacingMap["sidebar"] = 2] = "sidebar";
    ThemeSpacingMap[ThemeSpacingMap["stackedInput"] = 2] = "stackedInput";
    ThemeSpacingMap[ThemeSpacingMap["withExtraLeftSpacing"] = 2] = "withExtraLeftSpacing";
})(ThemeSpacingMap = exports.ThemeSpacingMap || (exports.ThemeSpacingMap = {}));
var ThemeType;
(function (ThemeType) {
    ThemeType["default"] = "default";
    ThemeType["sidebar"] = "sidebar";
    ThemeType["stackedInput"] = "stackedInput";
    ThemeType["withExtraLeftSpacing"] = "withExtraLeftSpacing";
})(ThemeType = exports.ThemeType || (exports.ThemeType = {}));
var FieldsetElement = styled_components_1.default.fieldset(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border: transparent;\n  padding: 0;\n  margin: 0;\n"], ["\n  background-color: ", ";\n  border: transparent;\n  padding: 0;\n  margin: 0;\n"])), function () { return b2c_theme_1.colors.white; });
var SpacingElement = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: ", ";\n"], ["\n  margin: ", ";\n"])), function (_a) {
    var spacing = _a.spacing;
    return "".concat(spacing, "rem ").concat(spacing, "rem ").concat(spacing, "rem 0;");
});
var DividerContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: ", ";\n"], ["\n  margin-left: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme) {
        case ThemeType.stackedInput:
            return '2.4rem';
        case ThemeType.withExtraLeftSpacing:
            return '4.8rem';
        default:
            return '0';
    }
});
var LegendText = (0, styled_components_1.default)(Typography_1.default)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var visuallyHideLegend = _a.visuallyHideLegend;
    return visuallyHideLegend
        ? (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          position: absolute;\n          overflow: hidden;\n          clip: rect(0 0 0 0);\n          height: 1px;\n          width: 1px;\n          margin: -1px;\n          padding: 0;\n          border: 0;\n        "], ["\n          position: absolute;\n          overflow: hidden;\n          clip: rect(0 0 0 0);\n          height: 1px;\n          width: 1px;\n          margin: -1px;\n          padding: 0;\n          border: 0;\n        "]))) : '';
});
var Fieldset = function (_a) {
    var children = _a.children, legend = _a.legend, legendProps = _a.legendProps, _b = _a.omitLastDivider, omitLastDivider = _b === void 0 ? false : _b, _c = _a.omitSpacing, omitSpacing = _c === void 0 ? false : _c, _d = _a.theme, theme = _d === void 0 ? ThemeType.default : _d, _e = _a.visuallyHideLegend, visuallyHideLegend = _e === void 0 ? false : _e, rest = __rest(_a, ["children", "legend", "legendProps", "omitLastDivider", "omitSpacing", "theme", "visuallyHideLegend"]);
    var _f = (0, react_1.useState)(ThemeSpacingMap.default), spacing = _f[0], setSpacing = _f[1];
    var _g = (0, react_1.useState)(false), includeDivider = _g[0], setIncludeDivider = _g[1];
    (0, react_1.useEffect)(function () {
        switch (theme) {
            case 'withExtraLeftSpacing':
                setSpacing(ThemeSpacingMap.withExtraLeftSpacing);
                setIncludeDivider(true);
                break;
            case 'sidebar':
                setSpacing(ThemeSpacingMap.sidebar);
                setIncludeDivider(true);
                break;
            case 'stackedInput':
                setSpacing(ThemeSpacingMap.stackedInput);
                setIncludeDivider(true);
                break;
            default:
                setSpacing(ThemeSpacingMap.default);
                setIncludeDivider(false);
        }
    }, [theme]);
    return (react_1.default.createElement(FieldsetElement, __assign({ "data-testid": "fieldset-element" }, rest),
        legend && (react_1.default.createElement(LegendText, __assign({ align: "left", allCaps: true, variant: Typography_1.TypeVariants.legend, component: "legend", theme: "label", visuallyHideLegend: visuallyHideLegend }, legendProps), legend)),
        react_1.default.Children.map(children, function (child, index) {
            return react_1.default.isValidElement(child) ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(SpacingElement, { spacing: omitSpacing ? 0 : spacing, "data-testid": "fieldset-spacing-element" }, react_1.default.cloneElement(child, {
                    'data-testid': 'fieldset-child',
                })),
                includeDivider &&
                    (index < react_1.default.Children.count(children) - 1 || !omitLastDivider) ? (react_1.default.createElement(DividerContainer, { "data-testid": "fieldset-divider-element-container", theme: theme },
                    react_1.default.createElement(Divider_1.default, null))) : null)) : null;
        })));
};
exports.default = Fieldset;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Fieldset.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/Fieldset/Fieldset.js
// module id = 1456
// module chunks = 2 5 14 15 17 19 20